import { render, staticRenderFns } from "./order-create-info.vue?vue&type=template&id=56f5a918&"
import script from "./order-create-info.ts?vue&type=script&lang=ts&"
export * from "./order-create-info.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports